import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class InventoryCategoryAPI extends DIApi {
  controllerName = 'InventoryCategorys'; // Cấu hình đúng tên Controller của backend

  /**
   * Tạo một API lấy dữ liệu load lên combobox
   * @param {*} param
   * @returns
   */
  getInventoryCategoryForCombobox(param) {
    const request = {
      url: this.getAPIUrl() + '/InventoryCategoryCombobox',
      data: param,
    };
    return httpClient.getAsync(request);
  }

  /**
   * check phát sinh loại vật tư ccdc
   * dvhung2 5/7/2023
   */
  CheckExistInventoryItem(inventoryCategoryId){
    const request = {
      url: this.getAPIUrl() + '/CheckExistInventoryItem',
      data: {inventoryCategoryId: inventoryCategoryId},
    }
    return httpClient.getAsync(request)
  }
}

export default new InventoryCategoryAPI();
